
import { Row, Col } from "react-bootstrap";
import { ComparisonContext } from "../../../../config/context/comparisonContext";
import { useContext } from "react";

const ComparePerformance = () => {

    const { compareDetails, setCompareDetails } = useContext(ComparisonContext);

    const carData = compareDetails.first || compareDetails.second || compareDetails.third || compareDetails.fourth
    const performanceSpecList = carData?.specs?.[7] // index 1 have engine specific records
    const firstCarSpecs = compareDetails?.first?.specs?.[7]
    const secondCarSpecs = compareDetails?.second?.specs?.[7]
    const thirdCarSpecs = compareDetails?.third?.specs?.[7]
    const fourthCarSpecs = compareDetails?.fourth?.specs?.[7]

    return (
        <div className="App">
            {performanceSpecList && Object.keys(performanceSpecList).map((spec: any, index: number) => (
                <Row className="border-bottom px-0" key={index}>
                    <Col md={2} className=" comparsion-img-out text-start border-end">
                        <p className="text-start mt-2">{performanceSpecList[spec].name}</p>
                    </Col>
                    <Col md={2} className="comparsion-img-out text-start border-end">
                        <p className="text-start text-dark is-description mt-2">{firstCarSpecs?.[spec].value || '-'}</p>
                    </Col>
                    <Col md={2} className="comparsion-img-out text-start border-end">
                        <p className="text-start text-dark is-description mt-2">{secondCarSpecs?.[spec].value || '-'}</p>
                    </Col>
                    <Col md={2} className="comparsion-img-out text-start border-end">
                        <p className="text-start text-dark is-description mt-2">{thirdCarSpecs?.[spec].value || '-'}</p>
                    </Col>
                    <Col md={2} className="comparsion-img-out text-start">
                        <p className="text-start text-dark is-description mt-2">{fourthCarSpecs?.[spec].value || '-'}</p>
                    </Col>
                </Row>
            )) }

        </div >
    );
};

export default ComparePerformance;
